import { render, staticRenderFns } from "./TransferTab1.vue?vue&type=template&id=63fb6590&scoped=true"
import script from "./TransferTab1.vue?vue&type=script&lang=js"
export * from "./TransferTab1.vue?vue&type=script&lang=js"
import style0 from "./TransferTab1.vue?vue&type=style&index=0&id=63fb6590&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63fb6590",
  null
  
)

export default component.exports